import React from "react"
import styled from "styled-components"
import * as actions from "../../integration/actions"
import MapIcon from "../../integration/images/MapIcon"
import Input from "buoy-input"
import { colors } from "buoy-theme"
import { Paragraph } from "buoy-core"
import { connect } from "react-redux"
import { inIframe } from "../../common/common"
import { defineMessages, injectIntl, FormattedMessage } from "react-intl"

const messages = defineMessages({
  zipcodeInputPlaceholder: {
    id: "zipcode.input.placeholder",
    defaultMessage: "Zip Code",
  },
})

const Container = styled.div`
  padding: 0;
  text-align: right;
  position: relative;
`

const ZipInput = styled(Input)`
  max-width: 128px;

  border: ${props =>
    props.error
      ? `1px solid ${colors.error(props)}`
      : `1px solid ${colors.neutralLightest(props)}`};

  &:focus {
    border: ${props =>
      props.error
        ? `1px solid ${colors.error(props)}`
        : `1px solid ${colors.white(props)}`};
    background: ${colors.white};
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  }
`

const errorMessage = "Invalid Zip Code"

const Error = styled(Paragraph)`
  position: absolute;
  top: 50px;
  right: 0;
`

class ZipcodeContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      inputAttempted: false,
      valid: false,
      lastZipcodeRequested: props.zipcode || "",
    }
  }

  componentDidMount = () => {
    this.props.setZipcode(this.props.zipcode)
    this.validateZip(this.props.zipcode)
  }

  onFocus = e => {
    e.stopPropagation()
    e.target.select()
  }

  onBlur = e => {
    e.stopPropagation()
    if (this.props.zipcode !== this.state.lastZipcodeRequested) {
      this.props.submit()
      this.setState({ lastZipcodeRequested: this.props.zipcode })
    }
  }

  keyDown = e => {
    let key = e.keyCode || e.which
    if (key === 13) {
      e.target.blur(e)
    }
  }

  onChange = e => {
    let zip = ("" + e.target.value).replace(/\D/g, "").slice(0, 5)
    this.props.setZipcode(zip)
    this.validateZip(zip)
    this.setState({ inputAttempted: true })
  }

  validateZip = zip => {
    let valid = zip.length === 5
    this.setState({ valid: valid })
  }

  render() {
    let showError =
      (!this.state.valid && this.state.inputAttempted) || this.props.error
    return (
      <Container>
        <MapIcon
          inline
          width="18px"
          height="23px"
          marginRight="8px"
          display="inline-flex"
        />
        <ZipInput
          autoFocus={this.props.alarmFocus && !inIframe()}
          placeholder={this.props.intl.formatMessage(
            messages.zipcodeInputPlaceholder
          )}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          value={this.props.zipcode}
          onKeyDown={this.keyDown}
          onChange={this.onChange}
          error={showError}
        />
        {showError && (
          <Error fontSize="bodySmall" margin="0" color="error">
            <FormattedMessage
              id="zipcode.input.invalid"
              defaultMessage={errorMessage}
            />
          </Error>
        )}
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  zipcode: state.integration.zipcode,
  error: state.integration.zipcodeError,
})

const mapDispatchToProps = dispatch => ({
  setZipcode: value => {
    dispatch(actions.setZipcode(value))
  },
  submit: () => dispatch(actions.submitLocationZip()),
})

const ZipcodeContainerWrapper = connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ZipcodeContainer))

export { ZipcodeContainerWrapper as default, ZipcodeContainer }



// WEBPACK FOOTER //
// ./assets/completion/components/ZipcodeInput.js